module.exports = __webpack_public_path__ + "img/icon-inquiry.2afc7b37.png";